import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import store from '../store'
import router from '../router/index'
import {getToken} from '@/utils/auth'

// 创建axios实例
const service = axios.create({
    baseURL: process.env.BASE_API, // api的base_url
    timeout: 25000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
    if (store.getters.token) {
        config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['Admin-Type'] = 'PLATFORM'  //后台管理端类型
    return config
}, error => {
    // 处理请求错误
    console.log(error) // for debug
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        /**
         * code为非200是抛错 可结合自己业务进行修改
         */
        const res = response.data
        if (res.code !== 200) {
            if (res.code !== 403){
                Message({
                    message: res.message,
                    type: 'error',
                    duration: 4 * 1000
                })
            }
            // 401:未登录;
            if (res.code === 401) {
                MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('FedLogOut').then(() => {
                        location.reload()// 为了重新实例化vue-router对象 避免bug
                    })
                })
            }
            if (res.code === 403 && res.message === "没有相关权限") {
                console.log("403：没有相关权限");
                // router.back();
                // store.dispatch('tagsView/delView', router); //关闭当前页面
                router.replace({path: '/err/401'});
            }
            return Promise.reject('操作失败')
        } else {
            return response.data
        }
    },
    error => {
        console.log('====报错了:' + error);
        const data = error.response.data;
        console.log('报错了:' + data)// for debug
        /*Message({
            message: data.message,
            type: 'error',
            duration: 4 * 1000
        })*/
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js